import { useEffect, useState } from 'react';
import { getModelIdForOrganization, CLAUDE_45_SONNET_MODEL_ID } from '../utils/modelSelection';
import organisationSettingsService from '../services/organisationSettingsService';

/**
 * Hook to get the appropriate AI model based on organization settings
 * Returns the model ID and loading state
 */
export function useModelSelection() {
  const [modelId, setModelId] = useState<string>(CLAUDE_45_SONNET_MODEL_ID); // Default to Premium
  const [loading, setLoading] = useState(true);
  const [aiModelTier, setAiModelTier] = useState<string>('Premium');

  useEffect(() => {
    async function loadModel() {
      try {
        const settings = await organisationSettingsService.getOrganisationSettings();
        const tier = settings.aiModel || 'Premium';
        const selectedModel = getModelIdForOrganization(tier);
        
        setAiModelTier(tier);
        setModelId(selectedModel);
        
        console.log(`🤖 Using ${tier} AI Model:`, selectedModel.substring(0, 50) + '...');
      } catch (error) {
        console.error('Error loading model selection:', error);
        // Default to Premium on error
        setAiModelTier('Premium');
        setModelId(CLAUDE_45_SONNET_MODEL_ID);
      } finally {
        setLoading(false);
      }
    }
    
    loadModel();
  }, []);

  return { 
    modelId, 
    loading, 
    aiModelTier,
    isPremium: aiModelTier === 'Premium',
    isPremiumSmall: aiModelTier === 'Premium Small',
    isStandard: aiModelTier === 'Standard'
  };
}

